const BASE = '/wp-json/pfandpirat/v1/loot-redemptions';

function headers(extra = {}) {
  const nonce = window?.pfandpiratData?.nonce || '';
  return {
    ...(nonce ? { 'X-WP-Nonce': nonce } : {}),
    ...extra,
  };
}

async function parse(response) {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.message || 'Einlösung konnte nicht verarbeitet werden.');
  }
  return payload;
}

export async function getLootRedemptions() {
  return parse(await fetch(BASE, { credentials: 'include', headers: headers() }));
}

export async function startLootRedemption(quantity) {
  return parse(await fetch(BASE, {
    method: 'POST',
    credentials: 'include',
    headers: headers({
      'Content-Type': 'application/json',
      'Idempotency-Key': `app-start-${Date.now()}-${window.crypto?.randomUUID?.() || Math.random().toString(16).slice(2)}`,
    }),
    body: JSON.stringify({ quantity }),
  }));
}

export async function resumeLootRedemption(redemptionId) {
  return parse(await fetch(`${BASE}/${encodeURIComponent(redemptionId)}/resume`, {
    method: 'POST',
    credentials: 'include',
    headers: headers(),
  }));
}

export async function cancelLootRedemption(redemptionId) {
  return parse(await fetch(`${BASE}/${encodeURIComponent(redemptionId)}/cancel`, {
    method: 'POST',
    credentials: 'include',
    headers: headers(),
  }));
}
